<template>
  <div class="Rule">
    <r_header></r_header>
    <div class="markdown">
      <div class="md">
      </div>
    </div>
    <div class="button">
      <start_button></start_button>
    </div>
  </div>
</template>

<script>
 // @ is an alias to /src

 import SideBar from '@/components/SideBar.vue';
 import MyButton from '@/components/Button.vue';
 import VueMarkdown from 'vue-markdown'
import AUHeader from '@/components/aboutus/Header.vue';

import StartButton from '@/components/contest/StartButton.vue'

 export default {
   name: 'Rule',
   computed: {
     links () {
       return this.$store.state.sbar.linksRule
     },
     buttonStyle() {
       return {
         width: '62.5vw'
       }
     }
   },
   data () {
     return {
       rule: ''
     }
   },
   mounted() {
       this.$http.get('/oss/markdown/rule-ai4sd-summer.md')
           .then(res => {
             this.rule = res.data
       })
   },
   methods: {
     showModal () {
       this.$modal.show('payment-modal')

     }
   },

   components: {
     my_button: MyButton,
     r_header: AUHeader,
     side_bar: SideBar,
     vue_markdown: VueMarkdown,
     start_button: StartButton,
   }
 }
</script>

<style scoped>
 .markdown{
   margin-top: 5.2vw;
   margin-bottom: 5.2vw;
   display: flex;
   flex-direction: column;
   align-items:center;
   justify-content: center;
 }
 .md{
   width: 62.5vw;
   height: 40vh;
   overflow-y: scroll;
   text-align: left;
   box-sizing: border-box;
   padding: 3.125vw 2.6vw 1vw 2.6vw;
   line-height: 1.875vw;
 }
.button {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

@media (min-width: 320px) and (max-width: 480px) {
  .md{
    width: 100vw;
   line-height: normal;
  }
 }

</style>
<style>
 .md a{
   color: #FFBA84 !important;
 }
</style>
